import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEdCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Ed (Bachelor of Education)",
    shortName: "B.Ed",
    duration: "2 years",
    description: "Professional teacher training program for school education",
    overview: "Bachelor of Education (B.Ed) is a 2-year professional degree program that prepares graduates to become qualified teachers for elementary and secondary education. This course focuses on teaching methodology, child psychology, educational technology, and curriculum development, combining theoretical knowledge with practical teaching experience through internships and practice teaching.",
    eligibility: [
      "Bachelor's degree from recognized university",
      "Minimum 50% marks in graduation (45% for SC/ST)",
      "Subject combination as per teaching requirements",
      "Valid entrance exam scores (state-level)",
      "Age limit varies by state (usually 21-35 years)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Childhood and Growing Up",
          "Contemporary India and Education",
          "Learning and Teaching",
          "Language across Curriculum",
          "Understanding Disciplines & Subjects",
          "Educational Technology"
        ]
      },
      {
        year: 2,
        subjects: [
          "Knowledge and Curriculum",
          "Assessment for Learning",
          "Creating Inclusive School",
          "School Management & Leadership",
          "Teaching Methodology (Subject-specific)",
          "Internship & Practice Teaching"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "School Teacher (Primary/Secondary)",
        "Education Coordinator",
        "Curriculum Developer",
        "Educational Counselor",
        "Principal/Vice Principal",
        "Education Consultant",
        "Training & Development Officer",
        "Educational Content Writer",
        "Online Education Specialist",
        "Special Education Teacher"
      ],
      industries: [
        "Government Schools",
        "Private Schools",
        "International Schools",
        "Educational NGOs",
        "Online Education Platforms",
        "Educational Publishing",
        "Training Institutes",
        "Coaching Centers",
        "Corporate Training",
        "Educational Consulting"
      ],
      averageSalary: "₹3-6 LPA (Fresher), ₹8-20 LPA (Experienced)",
      topRecruiters: [
        "State Education Departments",
        "CBSE/ICSE Schools",
        "International Schools",
        "Kendriya Vidyalaya Sangathan",
        "Navodaya Vidyalaya Samiti",
        "Educational NGOs"
      ]
    },

    admissionProcess: [
      "State-level entrance examination",
      "Merit-based admission on graduation marks",
      "Counseling and document verification",
      "Medical fitness certificate",
      "Character certificate from previous institution",
      "Fee payment and college reporting"
    ],

    topColleges: [
      {
        name: "Regional Institute of Education",
        location: "Various Cities (NCERT)",
        fees: "₹50,000",
        ranking: "Central Government"
      },
      {
        name: "Jamia Millia Islamia",
        location: "New Delhi",
        fees: "₹25,000",
        ranking: "Central University"
      },
      {
        name: "University of Madras",
        location: "Chennai",
        fees: "₹30,000",
        ranking: "State University"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹1.2 Lakhs",
        ranking: "Private University"
      }
    ],

    skills: [
      "Teaching Methodology",
      "Classroom Management",
      "Child Psychology Understanding",
      "Communication Skills",
      "Educational Technology",
      "Assessment & Evaluation",
      "Curriculum Planning",
      "Student Counseling",
      "Subject Matter Expertise",
      "Leadership & Administration"
    ],

    futureScope: "Growing opportunities in digital education, special education, educational technology, and international schools with increasing focus on quality education and innovative teaching methods.",

    faqs: [
      {
        question: "Is B.Ed mandatory to become a teacher?",
        answer: "Yes, B.Ed is mandatory for teaching in recognized schools (Classes I-XII) as per NCTE guidelines. However, some states may have different requirements for primary education."
      },
      {
        question: "Can I pursue B.Ed after any graduation stream?",
        answer: "Yes, graduates from any stream can pursue B.Ed. However, you need to have studied the subjects you want to teach either in graduation or at 10+2 level."
      },
      {
        question: "What are the government job opportunities for B.Ed graduates?",
        answer: "B.Ed graduates can apply for teacher positions in government schools, Kendriya Vidyalayas, Navodaya Vidyalayas, and other government educational institutions through various recruitment exams."
      },
      {
        question: "Can I pursue higher education after B.Ed?",
        answer: "Yes, you can pursue M.Ed (Master of Education), M.Phil in Education, Ph.D in Education, or specialized diplomas in areas like Special Education or Educational Technology."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEdCoursePage;
